<template>
  <div class="preview-panel">
    <h3 class="preview-title">{{ $t("common.previewStructure") }}</h3>
    <div class="tree-container eg-tree">
      <Tree
        :value="nodes"
        selection-mode="single"
        :selection-keys="localSelectedNode"
        @update:selection-keys="updateSelectedNode"
      >
        <template #default="{ node }">
          <eg-icon
            :icon="node.icon"
            :class="{
              'folder-icon': node.icon === 'folder',
              'last-folder':
                node.icon === 'folder' &&
                !(node.children && node.children.length),
            }"
          />
          <div class="node-label">{{ node.label }}</div>
        </template>
      </Tree>
    </div>
  </div>
</template>

<script>
import Tree from "primevue/tree";

export default {
  name: "PreviewTree",
  components: {
    Tree,
  },
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    selectedNode: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localSelectedNode: this.selectedNode,
    };
  },
  watch: {
    selectedNode(newVal) {
      this.localSelectedNode = newVal;
    },
  },
  methods: {
    updateSelectedNode(newSelection) {
      this.$emit("update:selected-node", newSelection);
    },
  },
};
</script>

<style scoped lang="scss">
.preview-panel {
  background: var(--color-surface-neutral-container-1);
  padding-left: 24px;
  padding-top: 24px;
}

.preview-title {
  color: var(--color-text-neutral-on-white);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0 0 16px 0;
  font-family: Inter, sans-serif;
}

.tree-container {
  overflow-y: auto;
  max-height: 500px;
  width: 280px;
  background-color: var(--color-surface-neutral-default);
  border-radius: 12px;
  border: 1px solid var(--color-stroke-neutral-default);
  padding: 24px;
}

.node-label {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
